import React, { useEffect, useState } from "react";
import "./Shipping.scss";
import { Col, Form, Image, InputGroup, Row } from "react-bootstrap";
import cartLoader from '../../../assets/images/cart_Loader.gif';
import useLoader from "../../../contexts/LoaderContext";
import { useTranslation } from "react-i18next";
interface ShippingOption {
  id: number;
  description: string;
  cost: {
    currency: string;
    value: number;
  };
  costWithDiscount: {
    currency: string;
    value: number;
  };
  formattedCost: string;
  formattedCostWithDiscount?: string;
}
interface shippingPlaceObj { label: string, value: string }
interface ShippingOptionsProps {
  partner: boolean;
  isDirect:boolean;
  shippingList: {
    shippingOption: ShippingOption[];
  };
  shippingPlace: {
    shippingToList: shippingPlaceObj[];
  };
  defaultShippingMethodCode?: any; // New prop for the default shipping method code
  validationErrors: Record<string, string>;
  onInputChange: (fieldName: string, value: any) => void; // Callback function for parent component
}
const Shipping: React.FC<ShippingOptionsProps> = ({ partner, isDirect, shippingList, shippingPlace, defaultShippingMethodCode, validationErrors, onInputChange }) => {
  const [shippingOptionsList, setShippingOptionsList] = useState<ShippingOption[] | null>(null);
  const [selectedshippingToOption, setShippingToOption] = useState("residence");
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  const { isCartLoading } = useLoader();
  const shippingMethodList = shippingList['shippingOption']
  const shippingPlaceList = shippingPlace['shippingToList']
  const { t } = useTranslation();
  useEffect(() => {
    if (shippingMethodList && shippingMethodList.length > 0) {
      setShippingOptionsList(shippingMethodList);
    }
    if (defaultShippingMethodCode?.shippingOption !== undefined && defaultShippingMethodCode?.shippingOption !== null) {
      setSelectedOption(Number(defaultShippingMethodCode.shippingOption));
    } else {
      setSelectedOption(null);
    }
    defaultShippingMethodCode?.shippingTo ? setShippingToOption(defaultShippingMethodCode.shippingTo) : setShippingToOption('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultShippingMethodCode, shippingMethodList]);

  const handleShippingMethodChange = (field: string, e: any) => {
    // if (!e) {
    //   e = defaultShippingMethodCode.shippingOption;
    // }
    onInputChange(field, Number(e));
    setSelectedOption(Number(e));
  };

  const handleShippingToChange = (field: string, e: any) => {
    setShippingToOption(e);
    onInputChange(field, e);
  };

  return (
    <div className="ShippingOption">
      {shippingOptionsList && (
        <Row xs={'auto'} md={'auto'} className="shippingDetails mb-4">
          <Col md={(partner && isDirect)?12:6}>
            <h3>{t('SHIPPING_METHOD_TITLE')}</h3>
            <div className={isCartLoading ? `cart-loading` : ''}>
              {isCartLoading && <Image src={cartLoader} className="cartLoader" alt="CartLoader"></Image>}
              <InputGroup className="mb-3 shippingMethod">
                {shippingOptionsList?.map((option: ShippingOption) => (
                  <Form.Group controlId="shippingOption" key={option.id} className="radioGroup">
                    <Form.Check
                      type="radio"
                      name="shippingOption"
                      id={`shippingOption-${option.id}`}
                      value={`${option.id}`}
                      label={
                        <span className="labelWrapper" style={{ 'float': partner ? 'left' : 'right' }}>
                          <span className="radioLabels">
                            <span className="description">{option.description}&#160;</span>
                            <span className="cost">
                              {(option?.formattedCostWithDiscount && option.formattedCost !== option.formattedCostWithDiscount) ? option.formattedCostWithDiscount : option.formattedCost}
                            </span>
                          </span>
                        </span>
                      }
                      checked={selectedOption === option['id']}
                      isInvalid={!!validationErrors.shippingOption}
                      onChange={(e) => handleShippingMethodChange('shippingOption', e.target.value)}
                    />
                    <Form.Control.Feedback type="invalid">{validationErrors.shippingOption}</Form.Control.Feedback>
                  </Form.Group>
                ))}
              </InputGroup>
            </div>
          </Col>
          {!partner && (<Col md={6}>
            <h3>{t('nvidiaSI_SHIPPING_TO')}</h3>
            <InputGroup className="mb-3 shippingTo">
              {shippingPlaceList?.map((option: shippingPlaceObj, index: number) => (
                <Form.Group controlId="shippingTo" key={option.value} className="radioGroup">
                  <Form.Check
                    type="radio"
                    name="shippingTo"
                    id={`shippingTo-${index}`}
                    value={`${option.value}`}
                    label={
                      <span className="labelWrapper">
                        <span className="radioLabels">
                          <span>{option.label}</span>
                        </span>
                      </span>
                    }
                    isInvalid={!!validationErrors.shippingTo}
                    checked={selectedshippingToOption === option.value}
                    onChange={(e) => handleShippingToChange('shippingTo', e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">{validationErrors.shippingTo}</Form.Control.Feedback>
                </Form.Group>
              ))
              }
            </InputGroup>
          </Col>)}
        </Row>
      )}
    </div>
  );
};
export default Shipping;
